import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/seo/SEO';
import LoginWithMfa from '../components/auth/LoginWithMfa';
import SignupForm from '../components/auth/SignupForm';
import { useAuth } from '../hooks/useAuth';

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect if user is already authenticated
  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/home');
    }
  }, [isAuthenticated, navigate]);

  const toggleForm = () => {
    setIsLogin(!isLogin);
  };

  return (
    <>
      <SEO
        title={isLogin ? "Login" : "Sign Up"}
        description="Sign in or create an account to access Studio - Agentic AI data engineering and data science platform."
        url="https://studio.thinkingdbx.com/auth"
      />
      <div className="w-full h-full">
        {isLogin ? (
          <LoginWithMfa onToggleForm={toggleForm} />
        ) : (
          <SignupForm onToggleForm={toggleForm} />
        )}
      </div>
    </>
  );
};

export default AuthPage;